
import { editsystemsetting, getcurrencys, getlanguages, getzonelist } from '@/api';
import router from '@/router';
import store from '@/store';
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios'
import { useI18n } from '@/utils/i18n';
import { setLanvuage } from '@/api/base';
import { saveValue } from '@/utils/common';
import { message } from 'ant-design-vue';

export default defineComponent({
    props:{
        type: {
            type: Number,
            default:0
        }
    },
    setup(props){
        const lan: any = useI18n();
        
        const routes = useRoute();
        console.log(routes.path);
        const types = ref(props.type)
        const zonelist=ref<any>([{
            city: "中途岛",
            gmt: "GMT-11:00",
            id: "Pacific/Midway",
            zoneid: 1

        }])
        const selectedzone=ref([])
        const currencylist=ref<any>([{
            alias: "CNY",
            code: "104110041000",
            createdAt: "2020-08-19 11:54:59",
            deletedAt: null,
            dictionaryid: 241,
            name: "人民币￥",
            position: 1,
            publish: 1,
            updatedAt: "2020-08-19 11:54:59",
            value: "1"
        }])
        const languagelist=ref<any>([{
            alias: "",
            code: "104110011000",
            createdAt: "2020-08-14 11:08:28",
            deletedAt: null,
            dictionaryid: 210,
            name: "中文",
            position: 1,
            publish: 1,
            updatedAt: "2020-08-14 11:08:28",
            value: "zh"
        }])
        console.log(types.value)
        interface Nav{
            name: string;
            route: string;
        }
        const nav: Array<Nav> = [
            {
                name: 'zhiboguanli',
                route: "/regime/live"
            },
            {
                name: 'shipinguanli',
                route: "/regime/video"
            },
            {
                name:  'dingyuezheguanli',
                route: "/regime/subscriber"
            },
            {
                name: 'gerenzhongxin',
                route: "/mine/archives"
            }
        ]
        const userinfo = computed(() => {
            return store.state.userinfo;
        })
        const nowroute=ref<string>("")

        const islogin = computed(()=>store.state.islogin)
        
        function navto(index: number | string){
            if(!store.state.islogin){
                message.error(lan.$s() == "zh" ? "登录后即可查看" : 'After logging in, you can view it')
               return ; 
            }
            if(typeof index == "number"){
                nowroute.value=nav[index].route
                router.push({
                    path: nav[index].route
                })
            }else{
                router.push(index)
            }
            
        }
        onMounted(async () => {
            zonelist.value=await getzonelist()
            // console.log(zonelist.value)
            // currencylist.value=await getcurrencys()
            languagelist.value=await getlanguages()
            console.log(routes.path)
            nowroute.value=routes.path
            // lan.locale.value = userinfo.value.languageValue
        })
        
        function zonechange(e?: any){
            // console.log(e,1002)
            editsystemsetting({zoneid:e})
        }
        function currencychange(e?: any){
            console.log(e)
            editsystemsetting({currency:parseInt(e)})
        }
        function setlanguage(e?: any){
            console.log(e)
            saveValue("Lanvuage", e)
            if(store.state.islogin){
                editsystemsetting({language:e})
            }else {
                location.reload();
                // setLanvuage(e)
            }
            // lan.locale.value = e
            
        }
        function toindex(){
            if(!store.state.islogin){
               return ; 
            }
            router.push("/mine/archives")
        }

        return {
            nav,
            types,
            navto,
            userinfo,
            zonelist,
            zonechange,
            selectedzone,
            currencylist,
            currencychange,
            languagelist,
            setlanguage,
            nowroute,
            toindex,
            lan,
            islogin
        }
    }
})
